// extracted by mini-css-extract-plugin
module.exports = {"ingredientIcons":"ingredients-icons-list_ingredientIcons__3F-Br","ingredientsItem":"ingredients-icons-list_ingredientsItem__1doBA"};